import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

export const S_TextNumberValue = styled.input`
    outline: none;
    border-top: none;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    padding: 0 10px;
    border-radius: 7px;
    font-size: 12px;
    color: #141c54;
    font-family: ${EFonts.Regular};
    width: ${(props) => (props.width ? props.width : '100%')};
    font-size: 12px;
    border-bottom: 1px solid #dadada;
    background: #f5f5f5;
    box-shadow: 0px 0px 20px 0px #dedede inset;
    height: 40px;
    text-align: center;
    &:focus {
        background: #f5f5f5;
    }
    &::placeholder {
        color: #909090;
    }
`;
